<template>
  <v-dialog
    :value="value"
    @input="v => $emit('input', v)"
    fullscreen
    transition="fade-transition"
  >
    <div class="wrapper" @click="$emit('input', null)">
      <div>
        <div class="text-center">
          <img class="theImage" :src="src" v-if="src != null" />
        </div>
        <div class="actions">
          <v-btn text color="white" class="mr-2" @click.stop="download">
            <v-icon>mdi-download</v-icon>
            Download
          </v-btn>
          <v-btn text color="white" class="ml-2" @click="$emit('remove')">
            <v-icon>mdi-delete</v-icon>
            Remover
          </v-btn>
        </div>
      </div>
    </div>
  </v-dialog>
</template>

<script>
import { saveBlobAs } from 'oderon-vue/utils.js'

export default {
  props: {
    value: {},
    src: {}
  },
  methods: {
    async download() {
      let res = await fetch(this.src)
      let blob = await res.blob()
      saveBlobAs(blob, 'image.png')
    }
  }
}
</script>

<style lang="sass" scoped>
.wrapper
  height: 100%
  width: 100%
  padding: 50px
  background-color: rgb(0 0 0 / 80%)

  .theImage
    max-height: calc(100vh - 175px)
    max-width: calc(100vw - 100px)

  > div
    height: calc(100vh - 100px)
    width: calc(100vw - 100px)
    overflow: auto
    display: flex
    flex-flow: column

.actions
  margin-top: 16px
  display: flex
  flex-flow: row nowrap
  align-items: center
  justify-content: center
</style>
